

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { lazy, Suspense } from 'react';

import type { EntitySummary, EventSummary, NarrativeSummary } from '@/lib/types';

interface MapComponentProps {
  events: EventSummary[];
  locations: EntitySummary[];
  scenes: NarrativeSummary[];
}

// Dynamically import the map component
const MapComponent = lazy<React.ComponentType<MapComponentProps>>(() =>
  import('./map-component').then(mod => ({ default: mod.default }))
);

interface TimelineMapViewProps {
  events: EventSummary[];
  locations: EntitySummary[];
  scenes: NarrativeSummary[];
}

export function TimelineMapView({ events, locations, scenes }: TimelineMapViewProps) {
  return (
    <Box sx={{ height: '100%', position: 'relative' }}>
      <Suspense fallback={
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularProgress />
        </Box>
      }>
        <MapComponent events={events} locations={locations} scenes={scenes} />
      </Suspense>
    </Box>
  );
}
